import { UserRound } from "lucide-react";
import { useGuest } from "@/context/GuestContext";
import { usePlatform } from "@/lib/platform";

export const GuestActions = () => {
  const { openAuth } = useGuest();
  const { registrations_open: regOpen } = usePlatform();
  return (
    <div className="flex items-center gap-2" data-testid="guest-actions">
      <button data-testid="header-sign-in-btn" onClick={() => openAuth()} className="hidden sm:inline-flex btn-ghost-gold px-4 py-2 text-sm">Sign in</button>
      {regOpen !== false && <button data-testid="header-sign-up-btn" onClick={() => openAuth({ mode: "register" })} className="hidden sm:inline-flex btn-gold px-4 py-2 text-sm">Sign up</button>}
      <button data-testid="guest-chip" onClick={() => openAuth()} aria-label="Guest — sign in" className="flex h-10 items-center gap-1.5 rounded-full border border-[#D4AF37]/50 bg-[#050505]/70 px-3 text-xs font-bold uppercase tracking-[0.18em] text-[#F5C451] hover:border-[#FFD86A] hover:text-[#FFD86A] transition-colors">
        <UserRound className="h-4 w-4" /> Guest
      </button>
    </div>
  );
};
